import { useCV } from '../hooks/useCV'

const Footer = () => {
  const { name, location } = useCV()

  return (
    <footer className="border-t border-rule">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-8 flex flex-wrap items-center justify-between gap-3 text-sm text-mute">
        <p>
          © {new Date().getFullYear()} {name}, {location}
        </p>
        <a href="#" className="hover:text-ink underline underline-offset-4 decoration-rule">
          Back to top
        </a>
      </div>
    </footer>
  )
}

export default Footer
